export const configuredApiOrigin = (import.meta.env.VITE_BETA_API_ORIGIN ?? "").trim().replace(/\/$/, "");

export function recordMarketingEvent(eventName: "page_view" | "beta_form_view"): void {
  if (!configuredApiOrigin) return;
  void fetch(`${configuredApiOrigin}/v1/public/marketing/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      eventId: `mkt_${crypto.randomUUID()}`,
      eventName,
      sourcePage: window.location.href,
    }),
    keepalive: true,
  }).catch(() => undefined);
}
